// extracted by mini-css-extract-plugin
export default {"config":"config_config__Anefo"};